import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { css } from "glamor";
import Clipboard from "./Clipboard.js";
css.global("html", {
  display: "flex",
  flexDirection: "column",
  height: "100%"
});
css.global("body", { margin: 0, padding: 0 });
css.global("body, #app-root", {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0
});
css.global("a", { color: "inherit", textDecoration: "none" });
ReactDOM.render(
  <Router>
    <Clipboard />
  </Router>,
  document.getElementById("app-root")
);
